export function isKik() {
  return window.kik && window.kik.enabled;
}

export function isFb() {}

export default () => {};



// WEBPACK FOOTER //
// ./src/utils/platform.js